import { EInvoiceAddressSchemeType } from '@components'

import { TFunction } from 'i18next'

// The invalid-format copy depends on the e-invoice address scheme (id type): some schemes name the
// expected id (e.g. SIREN) while the rest fall back to the generic message. Add a scheme here as new
// scheme-specific copy is introduced.
const eInvoiceAddressInvalidFormatErrorTKeyByScheme: Partial<Record<EInvoiceAddressSchemeType, string>> = {
  [EInvoiceAddressSchemeType.SIRENE]: 'customer_modal.form.validation.e_invoice_address.SIRENE.error.invalid_format',
}

export const getEInvoiceAddressFieldInvalidFormatErrorMessage = (
  scheme: EInvoiceAddressSchemeType | undefined,
  t: TFunction,
): string => {
  const invalidFormatErrorMessageTKey =
    (scheme && eInvoiceAddressInvalidFormatErrorTKeyByScheme[scheme]) ??
    'customer_modal.form.validation.e_invoice_address.error.invalid_format'

  return t(invalidFormatErrorMessageTKey)
}
